var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartShoppingRegular2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5217_31199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0C0.334375 0 0 0.334375 0 0.75C0 1.16563 0.334375 1.5 0.75 1.5H2.17188C2.29062 1.5 2.39375 1.58438 2.41875 1.70312L4.03125 10.1719C4.23438 11.2344 5.1625 12 6.24062 12H15.25C15.6656 12 16 11.6656 16 11.25C16 10.8344 15.6656 10.5 15.25 10.5H6.24062C5.88125 10.5 5.57188 10.2438 5.50313 9.89062L5.33437 9H14.35C15.3688 9 16.2594 8.31875 16.5219 7.33437L17.8031 2.575C18.0188 1.78125 17.4187 1 16.5969 1H3.75312C3.46875 0.4 2.8625 0 2.17188 0H0.75ZM4.09688 2.5H16.2719L15.075 6.94375C14.9875 7.27187 14.6906 7.5 14.35 7.5H5.05L4.09688 2.5ZM5.5 16C5.89782 16 6.27936 15.842 6.56066 15.5607C6.84196 15.2794 7 14.8978 7 14.5C7 14.1022 6.84196 13.7206 6.56066 13.4393C6.27936 13.158 5.89782 13 5.5 13C5.10218 13 4.72064 13.158 4.43934 13.4393C4.15804 13.7206 4 14.1022 4 14.5C4 14.8978 4.15804 15.2794 4.43934 15.5607C4.72064 15.842 5.10218 16 5.5 16ZM16 14.5C16 14.1022 15.842 13.7206 15.5607 13.4393C15.2794 13.158 14.8978 13 14.5 13C14.1022 13 13.7206 13.158 13.4393 13.4393C13.158 13.7206 13 14.1022 13 14.5C13 14.8978 13.158 15.2794 13.4393 15.5607C13.7206 15.842 14.1022 16 14.5 16C14.8978 16 15.2794 15.842 15.5607 15.5607C15.842 15.2794 16 14.8978 16 14.5Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5217_31199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartShoppingRegular2);
export default __webpack_public_path__ + "static/media/cart-shopping-regular 2.52e68ec70705b052345137a985e0e395.svg";
export { ForwardRef as ReactComponent };